import { 
  // useRef,
  useCallback,
  useState
 } from "react";
import { utils, writeFileXLSX } from 'xlsx';
import {
  useTranslate,
  // IResourceComponentsProps,
  CrudFilters,
  // useGetLocale,
  // HttpError,
} from "@pankod/refine-core";
import dayjs, { Dayjs } from "dayjs";
import {
  Card,
  Row,
  Col,
  Breadcrumb,
  ExportButton,
	// DateField,
	// Space,
	List,
  Form,
	Table,
  Typography,
  DateField,
  DatePicker,
  Select,
  SelectProps,
  Space,
	// TextField,
	NumberField,
	useTable
} from "@pankod/refine-antd";
import {
	// IReportFilterVariables,
  // IQueryReport,
	IReportDataAmount
} from "interfaces";
import "./style.less"; 
// import { trimStart } from "lodash";

const { Text } = Typography;

export const ReportOrderList: React.FC = () => {
	// console.log("ReportStoreList props", props);
  // const { tableProps } = useTable<IReportDataAmount>({
	// 	// resource: props.group,
	// 	resource: "view_store_amount",
	// 	metaData: {
  //     select: "*",
  //     // select: "*, organizations:organization_id(title)",
  //   },
	// });

  const { RangePicker } = DatePicker;

  // const locale = useGetLocale();
  const t = useTranslate();
  // const [dateRange, setDateRange] = useState<[Dayjs, Dayjs]>();
  const [dateRange, setDateRange] = useState<[Dayjs, Dayjs]>([
    // dayjs().subtract(7, "days").startOf("day"),
    // dayjs().startOf("day"),
    dayjs().startOf("month").subtract(1, "month"),
    dayjs().endOf("month").subtract(1, "month"),
  ]);
  // const [start, end] = dateRange;

  // const query = {
  //   start,
  //   end,
  // };

  const [valGroup, setGroup] = useState<string>("view_store_amount");
  const handleChangeGroup = (value: string) => {
    if (value !== undefined) {
      setGroup(value);
    }
  }

  const disabledDate = (date: Dayjs) => date > dayjs();

  const selectGroup: SelectProps['options'] = [
		{ value: "view_org_amount", label: t("stores.fields.organizations") },
		{ value: "view_store_amount", label: t("orders.fields.store") },
	];

  const filterReport = (q) => {
    const [start, end] = q;
    const filters: CrudFilters = [];
    // console.log("filters", query);
    filters.push({
      field: "dt",
      operator: "gte",
      value: start ? start.format("YYYY-MM-DD").toString() : undefined,
      // value: q
      //   ? q.start
      //   : undefined,
    },
    {
      field: "dt",
      operator: "lte",
      // value: start.format("YYYY-MM-DD").toString(),
      value: end ? end.format("YYYY-MM-DD").toString() : undefined,
      // value: q
      //   ? q.end
      //   : undefined,
    });
    return filters;
  };

  const getReportGroup = (group: string) => {
    return group;
  };

  const getReportGroupDate = (group: string, dateRange: any) => {
    // console.log(`[10a] --------------------------`);
    const [start, end] = dateRange;
    // const firstDay = start.year().toString();
    // console.log(`[10b] --------------------------`);
    const stYear = `${start.year()}-01-01`;
    const enYear = `${end.year()}-12-31`;
    if (stYear === start.format("YYYY-MM-DD").toString() && enYear === end.format("YYYY-MM-DD")){
      if (group === 'view_org_amount') {
        return 'view_org_amount_year';
      }
      return 'view_store_amount_year';
    }
    // console.log(`[11] --------------------------`);
    const stMonth = start.month() < 10 ? `0${start.month() + 1}` : start.month() + 1;
    const enMonth = end.month() < 10 ? `0${end.month() + 1}` : end.month() + 1;
    const firstDay = start.year().toString() + '-' +  stMonth + '-01';
    const lastDay = end.year().toString() + '-' +  enMonth + '-' + dayjs(end).daysInMonth();
    // console.log(`[12] --------------------------`);
    if (firstDay !== start.format("YYYY-MM-DD").toString()) {
      console.log(`firstDay: ${firstDay} start: ${start.format("YYYY-MM-DD").toString()}`);
      if (group === 'view_org_amount') {
        return 'view_org_amount_day';
      }
      return 'view_store_amount_day';
    }
    // console.log(`[13] -------------------------- end: ${end.format("YYYY-MM-DD").toString()}`);

    // const resLastDey = end.format("YYYY-MM-DD").toString();
    if (lastDay !== end.format("YYYY-MM-DD").toString()) {
      // console.log(`lastDay: ${lastDay} end: ${end.format("YYYY-MM-DD").toString()}`);
      if (group === 'view_org_amount') {
    // console.log(`[14a] --------------------------`);
        return 'view_org_amount_day';
      }
    // console.log(`[14b] --------------------------`);
      return 'view_store_amount_day';
    }
    // console.log(`[14c] --------------------------`);
    
    // const ss = start.format("YYYY-MM-DD").toString().split("-")[1];
    // const se = end.format("YYYY-MM-DD").toString().split("-")[1];
    // console.log(`day start: {1} end: {2}`, ss, se)
    // value: start ? start.format("YYYY-MM-DD").toString() : undefined,
    return group;
  };

  // const normalizeData = (data: IReportDataAmount[]) => {
  //   const tableTitle = [
  //     {

  //     }
  //   ];
  //   // const normalizeData = data.map((item) => {
  //   //   return {
  //   //     ...item,
  //   //     dt: dayjs(item.dt).format("DD.MM.YYYY"),
  //   //   };
  //   // });
  //   return normalizeData;
  // }
	const { tableProps } = useTable<IReportDataAmount>({
		// resource: props.group,
		// resource: getReportGroup(valGroup),
		resource: getReportGroupDate(valGroup, dateRange),
    hasPagination: false,
    // initialFilter: filterReport(dateRange),
    permanentFilter: filterReport(dateRange),
    // onSearch: (params) => {
    //   const filters: CrudFilters = [];
    //   // filters.push({});
    //   // console.log('useTable :>> ', params);
    //   filters.push(
    //     {
    //           field: "dt",
    //           operator: "gte",
    //           value: start
    //             ? start[0].startOf("day").toISOString()
    //             : undefined,
    //         },
    //         {
    //           field: "dt",
    //           operator: "lte",
    //           value: end
    //             ? end[1].endOf("day").toISOString()
    //             : undefined,
    //         });
    //   // console.log('useTable.filters :>> ', filters);
    //   return filters;
    // },
		metaData: {
      select: "*",
      // select: "*, organizations:organization_id(title)",
    },
    // syncWithLocation: false
	});
  // console.log('object :>> ', query);
  // console.log('valGroup :>> ', valGroup);
  // console.log('tableProps :>> ', tableProps);

  // const { isLoading, triggerExport } = useExcel<IReportData>({
  //   // sorter,
  //   // filters,
  //   // pageSize: 50,
  //   // maxItemCount: 50,
  //   data: tableProps.dataSource,
  //   // mapData: (item) => {
  //   //     return {
  //   //         id: item.id,
  //   //         amount: item.amount,
  //   //         orderNumber: item.orderNumber,
  //   //         status: item.status.text,
  //   //         store: item.store.title,
  //   //         user: item.user.firstName,
  //   //     };
  //   // },
  // });

  // const ExcelFile = ReactExport.ExcelFile;
  // const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  // const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  //   var dataSet2 = [
  //       {
  //           name: "Johnson",
  //           total: 25,
  //           remainig: 16
  //       },
  //       {
  //           name: "Josef",
  //           total: 25,
  //           remainig: 7
  //       }
  //   ];

    // const dataSet = [
    //   { Name: "Bill Clinton", Index: 42 },
    //   { Name: "GeorgeW Bush", Index: 43 },
    //   { Name: "Barack Obama", Index: 44 },
    //   { Name: "Donald Trump", Index: 45 },
    //   { Name: "Joseph Biden", Index: 46 }
    // ];

    // console.log(`[b0] --- `);
    
    const reportTitle = () => {
    // console.log(`[b1] --- `);
      return `${t("report.titleFirs")} ${dateRange[0].format("DD.MM.YYYY")} - ${dateRange[1].format("DD.MM.YYYY")}`;
    };

    // const [pres, setPres] = useState([]);

    /* get state data and export to XLSX */
    // const tbl = useRef<HTMLTableElement>(null);
    const exportFile = useCallback(() => {
    // console.log(`[b2] --- `);
      const reportFileName = `report${dayjs().format("YYYYMMDDHHmmss")}.xlsx`;
      // console.log('reportFileName :>> ', reportFileName);
      // let dataSet: any = [];
      // let wsHeaders: any = [];
      // let colCnt = 0;
      // let orgLength = 0;
      // let dtLength = 0;

      const trTitle = t("stores.fields.title");
      let titleLength = trTitle.length;
      const trStore = t("orders.fields.store");
      let storeLength = trStore.length;
      // const trOrg = t("stores.fields.organizations");
      // const trMonth = t("dashboard.filter.month");
      // const trAmount = t("orders.fields.amount");
      // const trTotal = t("orders.fields.amount");
      const trTotal = t("report.titleTotal");
      let quantityLength = trTotal.length;
      let amountLength = trTotal.length;

      const dtList = tableProps.dataSource?.map((item) => item.dt);
      const dtUngine = Array.from(new Set(dtList));
      // console.log(dtUngine);
      let trMonthList: any = [];
      dtUngine.forEach((item) => {

        // trMonthList.push(`${trMonth} ${dayjs(item).format("MM.YYYY")}`);
      const showGroup = getReportGroupDate(valGroup, dateRange);
      if (showGroup === "view_store_amount_day" || showGroup === "view_org_amount_day") {
        trMonthList.push(`${dayjs(item).format("DD/MM/YYYY")}`);
      } else {
        trMonthList.push(`${dayjs(item).format("MMMM YYYY")}`);
      }
    });

      const titleListAmount = valGroup === "view_store_amount" ? [trTitle, trStore, ...trMonthList, trTotal] : [trTitle, ...trMonthList, trTotal];
      const titleListQuantity = valGroup === "view_store_amount" ? [trTitle, trStore, ...trMonthList, trTotal] : [trTitle, ...trMonthList, trTotal];
      // console.log('titleListAmount');
      // console.log(titleListAmount);

      // const tableTitle = { id, k: key, trTitle, store_id, store, cnt, amount, ...res.reduce((acc, item) => ({ ...acc, [item]: {quantity: 0, amount: 0} }), {}) };
      // let titleAmount = [trTitle, trStore];
      // let titleAmount = [trTitle, trStore, trMonth, trQuantity, trAmount];

      // tableProps.dataSource?.forEach((item) => {
      //   // console.log('item :>> ', item);
      //   // console.log('dt :>> ', dayjs(item.dt).format("MMMM YYYY"));
      //   // const trTitle = t("stores.fields.organizations");
      //   const currentLocale = locale();
      //   if (item.title.length > titleLength) {
      //     titleLength = item.title.length;
      //   };
      //   const amount = new Intl.NumberFormat(currentLocale, { style: 'currency', currency: 'UAH' }).format(item.amount)
      //   if (amount.length > amountLength) {
      //     amountLength = amount.length;
      //   };
      //   const quantityString = item.cnt.toString();
      //   if (quantityString.length > quantityLength) {
      //     quantityLength = quantityString.length;
      //   };
      //   const dt = dayjs(item.dt).format("MMMM YYYY");
      //   if (dt.length > dtLength) {
      //     dtLength = dt.length;
      //   }

      //   // if (item.organizations.length > orgLength) {
      //   //   orgLength = item.organizations.length;
      //   // };
      //   if (valGroup === "view_store_amount") {
      //     if (item.store.length > storeLength) {
      //       storeLength = item.store.length;
      //     };
      //     wsHeaders = [trTitle, trStore, trMonth, trQuantity, trAmount];
      //     // colCnt = 5;
      //     dataSet.push({
      //       title: item.title,
      //       store: item.store,
      //       dt: dt,
      //       quantity: item.cnt ? item.cnt : 0,
      //       // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
      //       amount: amount,
      //     });
      //   } else {
      //     wsHeaders = [trTitle, trMonth, trQuantity, trAmount];
      //     // colCnt = 4;
      //     dataSet.push({
      //       title: item.title,
      //       dt: dt,
      //       quantity: item.cnt ? item.cnt : 0,
      //       amount: amount,
      //     });
      //   }
      // });

      // if (trTitle.length > titleLength) {
      //   titleLength = trTitle.length;
      // }
      // if (trMonth.length > dtLength) {
      //   dtLength = trMonth.length;
      // };
      // if (trQuantity.length > quantityLength) {
      //   quantityLength = trQuantity.length;
      // };
      // if (trAmount.length > amountLength) {
      //   amountLength = trAmount.length;
      // };

      const result = tableProps.dataSource?.reduce((acc, item) => {
        const { id, title, store_id, store, posnum, amount, dt } = item;
        const key = `${id}_${store_id}`;
        if (!acc[key]) {
          acc[key] = { id, k: key, title, store_id, store, posnum: 0, amount: 0, ...dtUngine.reduce((acc, item) => ({ ...acc, [item]: 0 }), {}) };
        }
        acc[key].posnum += posnum;
        acc[key].amount += amount;
        acc[key][dt] = (acc[key][dt] || 0) + amount;
        return acc;
      }, {});
      const resultQuantity = tableProps.dataSource?.reduce((acc, item) => {
        const { id, title, store_id, store, posnum, amount, dt } = item;
        const key = `${id}_${store_id}`;
        if (!acc[key]) {
          acc[key] = { id, k: key, title, store_id, store, posnum: 0, amount: 0, ...dtUngine.reduce((acc, item) => ({ ...acc, [item]: 0 }), {}) };
        }
        acc[key].posnum += posnum;
        acc[key].amount += amount;
        acc[key][dt] = (acc[key][dt] || 0) + posnum; //Отображение в отчете
        return acc;
      }, {});

      // const ws = utils.json_to_sheet(dataSet);
      // const ws = utils.aoa_to_sheet([[`${t("report.titleFirs")} ${dateRange[0].format("DD.MM.YYYY")} - ${dateRange[1].format("DD.MM.YYYY")}`], titleListAmount, ...dataSet.map((item) => Object.values(item))]);
      if (result !== undefined && resultQuantity !== undefined) {
        // console.log('[1] result' + result);
        
        const rowsAmount = Object.values(result).map((item: any) => {
          // const { id, k, title, store_id, store, amount, ...rest } = item;
          // console.log('[2] item' + item);
          
          const { id, k, title, store_id, store, posnum, amount, ...rest } = item;
          // console.log(`[3] id: ${id}, k: ${k}, title: ${title}, store_id: ${store_id}, store: ${store}, amount: ${amount}`);
          
          if (title.length > titleLength) titleLength = title.length;
          if (amount.toString().length > amountLength) amountLength = amount.toString().length;
          if (valGroup === "view_store_amount") {
            if (store.length > storeLength) storeLength = store.length;
            return [title, store, ...Object.values(rest), amount];
            // return [title, store, ...rest, amount];
          }
          return { title, ...rest, amount };
          // return { id, k, title, store_id, store, amount, ...rest };
        });
        const rowsQuantity = Object.values(resultQuantity).map((item: any) => {
          const { id, k, title, store_id, store, posnum, amount, ...rest } = item;
          
          if (posnum.toString().length > quantityLength) quantityLength = posnum.toString().length;
          if (valGroup === "view_store_amount") {
            return { title, store, ...rest, posnum };
          }
          return { title, ...rest, posnum };
        });
        // console.log('rowsAmount');
        // console.log(Object.values(rowsAmount));
        // var a1_range = utils.encode_range({ s: { c: 0, r: 0 }, e: { c: 0, r: titleListAmount.length } });
        const colAmount = `${t("report.titleFirs")} ${dateRange[0].format("DD.MM.YYYY")} - ${dateRange[1].format("DD.MM.YYYY")}`;
        const colQuantity = `${t("report.titleQuantityFirst")} ${dateRange[0].format("DD.MM.YYYY")} - ${dateRange[1].format("DD.MM.YYYY")}`;

        const stylyTitle = {
          alignment: { horizontal: "center", vertical: "center" },
          fill: {
          patternType: "none", // none / solid
          fgColor: {rgb: "FF000000"},
          bgColor: {rgb: "FFFFFFFF"}
            },
            font: {
          name: 'Times New Roman',
          sz: 16,
          color: {rgb: "#FF000000"},
          bold: true,
          italic: false,
          underline: false
            },
            border: {
          top: {style: "thin", color: {auto: 1}},
          right: {style: "thin", color: {auto: 1}},
          bottom: {style: "thin", color: {auto: 1}},
          left: {style: "thin", color: {auto: 1}}
            }
        };

        const ws = utils.aoa_to_sheet([
          [{v: colAmount, t: 's',  s: stylyTitle}],
          // [{ colAmount, s: { c: 0, r: 0, alignment: { horizontal: "center" } }, e: { c: 0, r: titleListAmount.length } }],
          titleListAmount, 
          ...rowsAmount.map((item) => Object.values(item))
          // ...dataSet.map((item) => Object.values(item))
          // ...Object.values(result).map((item) => Object.values(item))
        ]);
        const wsQuantity = utils.aoa_to_sheet([
          [colQuantity],
          titleListQuantity, 
          ...rowsQuantity.map((item) => Object.values(item))
          // ...dataSet.map((item) => Object.values(item))
          // ...Object.values(result).map((item) => Object.values(item))
        ]);

        // utils.sheet_add_aoa(ws, [colAmount], { s: { c: 0, r: 0 }, e: { c: 0, r: titleListAmount.length } });
      
        // rowsAmount.forEach((item) => {
        //   if (item.title?.length > titleLength) titleLength = item.title.length;
        //   if (valGroup === "view_store_amount") {
        //     if (item.store?.length > storeLength) storeLength = item.store.length;
        //   }
        //   if (item.amount.toString().length > amountLength) amountLength = item.amount.toString().length;
        // });
        // rowsQuantity.forEach((item) => {
        //   if (item.cnt.toString().length > quantityLength) quantityLength = item.cnt.toString().length;
        // });
      
        ws["!merges"] = [{s: {c: 0, r: 0}, e: {c: (titleListAmount.length - 1), r: 0}}];
        wsQuantity["!merges"] = [{s: {c: 0, r: 0}, e: {c: (titleListQuantity.length - 1), r: 0}}];

        ws['!rows'] = [{hpx: 20}, {hpx: 20}, ...rowsAmount.map((item) => ({hpx: 20, z: '#,##0.00'}))];
        wsQuantity['!rows'] = [{hpx: 20}, {hpx: 20}, ...rowsAmount.map((item) => ({hpx: 20, z: '#,##0.00'}))];

        if (valGroup === "view_store_amount") {  
          // ws["!cols"] = [{ wch: titleLength }, { wch: storeLength }, { wch: dtLength }, { wch: quantityLength }, { wch: amountLength }];
          ws["!cols"] = [{ wch: titleLength }, { wch: storeLength }, ...trMonthList.map((itemMonth: string | any[]) => ({ wch: itemMonth.length })), { wch: amountLength }]
          wsQuantity["!cols"] = [{ wch: titleLength }, { wch: storeLength }, ...trMonthList.map((itemMonth: string | any[]) => ({ wch: itemMonth.length })), { wch: quantityLength }]
          // ws["!cols"] = [...titleListAmount.map((item) => ({ wch: item.length }))];
        } else {
          ws["!cols"] = [{ wch: titleLength }, ...trMonthList.map((itemMonth: string | any[]) => ({ wch: itemMonth.length })), { wch: amountLength }]
          wsQuantity["!cols"] = [{ wch: titleLength }, ...trMonthList.map((itemMonth: string | any[]) => ({ wch: itemMonth.length })), { wch: quantityLength }]
        }
        // const ws = utils.table_to_book(tbl.current);
        const wb = utils.book_new();
        // utils.sheet_add_aoa(ws, [[`${t("report.titleFirs")} ${dateRange[0].format("DD.MM.YYYY")} - ${dateRange[1].format("DD.MM.YYYY")}`]], { origin: "A1" });
        // // utils.sheet_add_aoa(ws, [wsHeaders], { origin: "A1" });
        // utils.sheet_add_aoa(ws, [titleListAmount], { origin: "A2" });
        utils.book_append_sheet(wb, ws, t("report.titleAmount"));
        utils.book_append_sheet(wb, wsQuantity, t("report.titleQuantity"));
        writeFileXLSX(wb, reportFileName);
      }
      
      // console.log(`[a03] --------------------------`);
    }, [t, tableProps.dataSource, dateRange, valGroup]);

  // const [isExport, setIsExport] = useState(false);

  // const Actions: React.FC = () => {
  //   console.log('tableProps :>> ', tableProps);
  //   if (tableProps.dataSource !== undefined && tableProps.dataSource.length > 0) {
  //     console.log('tableProps.dataSource :>> ', tableProps.dataSource);
  //     // let dataSet: any = [];
  //     // tableProps.dataSource.map((item) => {
  //     //  console.log('item :>> ', item);
  //     //   dataSet.push(item);
  //     //   // dataSet.push({
  //     //   //   name: item.title,
  //     //   //   quantity: item.cnt,
  //     //   //   amount: item.amount
  //     //   // });
  //     //   // return item;
  //     // });
  //     // setPres(dataSet);
  //     // console.log('dataSet2 :>> ', dataSet2);
  //     // setIsExport(true);
  //     // setPres(tableProps.dataSource);
  //   // } else {
  //     // setIsExport(false);
  //   }
  //   // setPres(tableProps.dataSource);
  //   return (
  //     <></>
  //   // <ExportButton onClick={triggerExport} loading={isLoading} />
  //   // <ExportButton disabled={!isExport} />
  //   // <ExportButton onClick={exportFile} disabled={!isExport} />
  //   // <ExportButton onClick={exportFile} />
  //   // <ExcelFile element={<button>Download Data</button>}>
  //   //   {/* <ExcelSheet data={reportData.value?.data} name="report"> */}
  //   //   <ExcelSheet data={dataSet2} name="Leaves">
  //   //     <ExcelColumn label="Name" value="name"/>
  //   //     <ExcelColumn label="Total Leaves" value="total"/>
  //   //     <ExcelColumn label="Remaining Leaves" value="remaining"/>
  //   //   </ExcelSheet>
  //   // </ExcelFile>
  //   )
  // };

  

  // const qDtMode = getDtPeriod(query);
  // console.log('qDtMode :>> ', qDtMode);
  return (
    <Row gutter={[16, 16]}>
      <Col xl={17} lg={16} md={24} sm={24} xs={24}>
        <Card title={<Text strong>{t("dashboard.reportRecent.title")}</Text>} >
          <List
            // pageHeaderProps={{extra: <Actions />, title: t("orders.pageHeader.title")}}
            pageHeaderProps={{
			    	  backIcon: false,
			    	  breadcrumb: <Breadcrumb hideIcons showHome={false} />,
			    	  // title: `${props.salesMonth}, ${props.salesYear}`,
			    	  title: reportTitle(),
              // extra: <Actions />,
              extra: <ExportButton onClick={exportFile} disabled={(tableProps.dataSource !== undefined && tableProps.dataSource.length > 0) ? false : true} />,
			      }}
          >
            
            <Table
            // ref={tbl}
              // dataSource={reportData.value ? reportData.value.data : []}
              // loading={reportData.loading}
              {...tableProps}
              // rowKey="id"
              // onRow={(record) => {
              //   return {
              //     onClick: () => {
              //       show("sales", record.id);
              //     },
              //   };
              // }}
            >
				<Table.Column
          key="title"
          dataIndex="title"
          // key="organization"
          // dataIndex="organization"
          title={t("stores.fields.organizations")}
          // defaultSortOrder={getDefaultSortOrder(
          //   "organizations.title",
          //   sorter,
          // )}
          // filterDropdown={(props) => (
          //   <FilterDropdown {...props}>
          //     <Select
          //       style={{ minWidth: 200 }}
          //       mode="multiple"
          //       placeholder={t("select.organization")}
          //       {...selectProps}
          //     />
          //   </FilterDropdown>
          // )}
        />
				{ valGroup === "view_store_amount" && (<Table.Column
          key="store"
          dataIndex="store"
          title={t("orders.fields.store")}
        />)}
        {/* {props.salesMonth === 0 && (<Table.Column
          key="sales_month"
          dataIndex="sales_month"
          title={t("dashboard.filter.month")}
          // render={(value) => {
          //   // return (ShowMonth({val: value}))
          //   return (value)
          // }}
        />)} */}
        <Table.Column
          key="dt"
          dataIndex="dt"
          title={t("dashboard.filter.month")}
          render={(value) => {
            // console.log(`value :>> ${value}`);
            const showGroup = getReportGroupDate(valGroup, dateRange);
            // console.log(`showGroup :>> ${showGroup}`);
            if (!value || value === "0001-01-01") {
              return <Space/>;
            } else if (showGroup === "view_store_amount_day" || showGroup === "view_org_amount_day") {
              return <DateField value={value} format="DD/MM/YYYY" />
            } else {
              return <DateField value={value} format="MMMM YYYY" />
            }
          }}
          // sorter
            />
				<Table.Column
          key="posnum"
          dataIndex="posnum"
          // key="quantity"
          // dataIndex="quantity"
          title={t("orders.fields.posnum")}
          // render={(value) => {
          //   value = `999`;
          //   // console.log('-------- value --------');
          //   // console.log(value);
          //   // return (ShowMonth({val: value}))
          //   return (value)
          // }}
        />
				<Table.Column
          align="right"
          key="amount"
          dataIndex="amount"
          title={t("orders.fields.amount")}
          // defaultSortOrder={getDefaultSortOrder(
          //   "amount",
          //   sorter,
          // )}
          // sorter
          render={(value) => {
            if (value === null || value === undefined) {
              value = 0;
            }
            // console.log('col amount :>> ', value);
            return (
              <NumberField
                options={{
                  currency: "UAH",
                  style: "currency",
                }}
                // value={value / 100}
                value={value}
                    />
                  );
                }}
              />
			      </Table>
          </List>
        </Card>
      </Col>
      <Col xl={7} lg={8} md={24} sm={24} xs={24}>
        <Card
          title={
            <Text strong>{t("dashboard.reportFilter.title")}</Text>
          }
        >
          {/* <Text>{t("rangePicker.placeholder")}</Text> */}
          <Form layout="vertical">
            <Form.Item label={t("rangePicker.placeholder")} name="dateRange">
            <RangePicker
              // className="range-picker"
              // size="small"
              value={dateRange}
              onChange={(values) => {
                if (values && values[0] && values[1]) {
                  setDateRange([values[0], values[1]]);
                }
              }}
            disabledDate={disabledDate}
            style={{ width: "100%" }}
            // style={{
            //   float: "right",
            //   color: "#fffff !important",
            //   background: "rgba(255, 255, 255, 0.3)",
            // }}
            ranges={{
              "This Week": [
                dayjs().startOf("week"),
                dayjs().endOf("week"),
              ],
              "Last Month": [
                dayjs().startOf("month").subtract(1, "month"),
                dayjs().endOf("month").subtract(1, "month"),
              ],
              "This Month": [
                dayjs().startOf("month"),
                dayjs().endOf("month"),
              ],
              "This Year": [
                dayjs().startOf("year"),
                dayjs().endOf("year"),
              ],
            }}
            format="YYYY/MM/DD"
          />
          </Form.Item>
          {/* <Text>{t("dashboard.filter.group")}</Text> */}
            <Form.Item label={t("dashboard.filter.group")} name="group">
              <Select
                options={selectGroup}
                style={{ width: "100%" }}
                // style={{
                //   float: "right",
                // }}
                // size="small"
                // {...OptionsOrderStatuses}
                // allowClear
                defaultValue="view_store_amount"
                onChange={handleChangeGroup}
                // clearIcon={false}
                // removeIcon={false}
                // placeholder={t("orders.filter.status.placeholder")}
              />
            </Form.Item>
          </Form>
        </Card>
      </Col>
			{/* <Table rowKey="id">
            <Table.Column
              key="dt"
              dataIndex="dt"
              title={t("orders.fields.store")}
              render={(value) => (
                (!value || value === "0001-01-01") ?  <Space/> : <DateField value={value} format="MMMM YYYY" />
              )}
              // sorter
            />
            <Table.Column
              key="title"
              dataIndex="title"
              title={t("orders.fields.store")}
            />
            <Table.Column
              key="store"
              dataIndex="store"
            />
				    <Table.Column
              key="cnt"
              dataIndex="cnt"
            />
				    <Table.Column
              align="right"
              key="amount"
              dataIndex="amount"
              title={t("orders.fields.amount")}
              render={(value) => {
                return (
                  <NumberField
                    options={{
                      currency: "UAH",
                      style: "currency",
                    }}
                    // value={value / 100}
                    value={value}
                  />
                );
              }}
            />
      </Table> */}
    </Row>
  );
};

// const getDtPeriod = (dateRange: IQueryReport) => {
//   console.log('-------- dateRange --------');

//   console.log('start :>> ', dateRange.start.format('YYYY-MM-DD').toString());
//   console.log('object :>> ', dateRange.start.startOf("day").toISOString());
//   if (dateRange.end !== undefined) {
//     console.log('end :>> ', dateRange.end.format('YYYY-MM-DD').toString);

//   }
//   // // if ((dayjs().startOf("week").format('YYYY-MM-DD').toString() === dateRange.start.format('YYYY-MM-DD').toString()) && (dayjs().endOf("week") === dateRange.end)) {
//   // if ((dayjs().startOf("week").format('YYYY-MM-DD').toString() === dateRange.start.format('YYYY-MM-DD').toString()) && (dayjs().endOf("week").format('YYYY-MM-DD').toString() === dateRange.end.format('YYYY-MM-DD').toString())) {
//   //   return "week";
//   // } else if ((dayjs().startOf("week").format('YYYY-MM-DD').toString() === dateRange.start.format('YYYY-MM-DD').toString()) && (dayjs().endOf("week").format('YYYY-MM-DD').toString() === dateRange.end.format('YYYY-MM-DD').toString())) {
//   //   return "last_month";
//   //   // return "month";
//   //   // return "year";
//   // }
//   // // ,)
//   // // dayjs.Dayjs, dayjs.Dayjs
//   // console.log('start :>> ', dateRange.start.toISOString());
//   // console.log('end :>> ', dateRange.end.toISOString());
//   console.log('last month start :>> ', dayjs().startOf("month").subtract(1, "month").toISOString());
//   console.log('last month end :>> ', dayjs().endOf("month").subtract(1, "month").toISOString());
//   console.log('month start :>> ', dayjs().startOf("month").toISOString());
//   console.log('month end :>> ', dayjs().endOf("month").toISOString());
//   console.log('year start :>> ', dayjs().startOf("year").format('YYYY-MM-DD').toString());
//   console.log('year end :>> ', dayjs().endOf("year").format('YYYY-MM-DD').toString());
//   return "day";
// }